import axios from 'axios'
import { reportFieldError } from '@/lib/field-errors'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => {
    const newExpiry = response.headers['x-session-expires']
    if (newExpiry) {
      localStorage.setItem('expiresAt', newExpiry)
    }
    return response
  },
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('expiresAt')
      window.location.href = '/login'
    }
    if (error.response?.data?.field) reportFieldError(error.response.data.field)
    return Promise.reject(error)
  },
)

export default api
